import { HexColor } from './portal-colors-hex';
import { TailwindPalette, TailwindCommonPalette, TailwindExtraPalette } from './tailwind-palette';

type TailwindCommonPaletteHex = {
  [key in TailwindCommonPalette]: HexColor;
};

type TailwindExtraPaletteHex = {
  [key in TailwindExtraPalette]: HexColor;
};

type TailwindPaletteHex = {
  [key in TailwindPalette]: HexColor;
};

const tailwindCommonPaletteHex: TailwindCommonPaletteHex = {
  // TailwindCommonPalette base colors
  [TailwindCommonPalette.TRANSPARENT]: '#FFFFFF00',
  [TailwindCommonPalette.WHITE]: '#FFFFFF',
  [TailwindCommonPalette.BLACK]: '#000000',

  // TailwindCommonPalette SLATE colors
  [TailwindCommonPalette.SLATE_50]: '#F8FAFC',
  [TailwindCommonPalette.SLATE_100]: '#F1F5F9',
  [TailwindCommonPalette.SLATE_200]: '#E2E8F0',
  [TailwindCommonPalette.SLATE_300]: '#CBD5E1',
  [TailwindCommonPalette.SLATE_400]: '#94A3B8',
  [TailwindCommonPalette.SLATE_500]: '#64748B',
  [TailwindCommonPalette.SLATE_600]: '#475569',
  [TailwindCommonPalette.SLATE_700]: '#334155',
  [TailwindCommonPalette.SLATE_800]: '#1E293B',
  [TailwindCommonPalette.SLATE_900]: '#0F172A',
  [TailwindCommonPalette.SLATE_950]: '#020617',

  // TailwindCommonPalette GRAY colors
  [TailwindCommonPalette.GRAY_50]: '#F9FAFB',
  [TailwindCommonPalette.GRAY_100]: '#F3F4F6',
  [TailwindCommonPalette.GRAY_200]: '#E5E7EB',
  [TailwindCommonPalette.GRAY_300]: '#D1D5DB',
  [TailwindCommonPalette.GRAY_400]: '#9CA3AF',
  [TailwindCommonPalette.GRAY_500]: '#6B7280',
  [TailwindCommonPalette.GRAY_600]: '#4B5563',
  [TailwindCommonPalette.GRAY_700]: '#374151',
  [TailwindCommonPalette.GRAY_800]: '#1F2937',
  [TailwindCommonPalette.GRAY_900]: '#111827',
  [TailwindCommonPalette.GRAY_950]: '#030712',

  // TailwindCommonPalette ZINC colors
  [TailwindCommonPalette.ZINC_50]: '#FAFAFA',
  [TailwindCommonPalette.ZINC_100]: '#F4F4F5',
  [TailwindCommonPalette.ZINC_200]: '#E4E4E7',
  [TailwindCommonPalette.ZINC_300]: '#D4D4D8',
  [TailwindCommonPalette.ZINC_400]: '#A1A1AA',
  [TailwindCommonPalette.ZINC_500]: '#71717A',
  [TailwindCommonPalette.ZINC_600]: '#52525B',
  [TailwindCommonPalette.ZINC_700]: '#3F3F46',
  [TailwindCommonPalette.ZINC_800]: '#27272A',
  [TailwindCommonPalette.ZINC_900]: '#18181B',
  [TailwindCommonPalette.ZINC_950]: '#09090B',

  // TailwindCommonPalette NEUTRAL colors
  [TailwindCommonPalette.NEUTRAL_50]: '#FAFAFA',
  [TailwindCommonPalette.NEUTRAL_100]: '#F5F5F5',
  [TailwindCommonPalette.NEUTRAL_200]: '#E5E5E5',
  [TailwindCommonPalette.NEUTRAL_300]: '#D4D4D4',
  [TailwindCommonPalette.NEUTRAL_400]: '#A3A3A3',
  [TailwindCommonPalette.NEUTRAL_500]: '#737373',
  [TailwindCommonPalette.NEUTRAL_600]: '#525252',
  [TailwindCommonPalette.NEUTRAL_700]: '#404040',
  [TailwindCommonPalette.NEUTRAL_800]: '#262626',
  [TailwindCommonPalette.NEUTRAL_900]: '#171717',
  [TailwindCommonPalette.NEUTRAL_950]: '#0A0A0A',

  // TailwindCommonPalette RED colors
  [TailwindCommonPalette.RED_50]: '#FEF2F2',
  [TailwindCommonPalette.RED_100]: '#FEE2E2',
  [TailwindCommonPalette.RED_200]: '#FECACA',
  [TailwindCommonPalette.RED_300]: '#FCA5A5',
  [TailwindCommonPalette.RED_400]: '#F87171',
  [TailwindCommonPalette.RED_500]: '#EF4444',
  [TailwindCommonPalette.RED_600]: '#DC2626',
  [TailwindCommonPalette.RED_700]: '#B91C1C',
  [TailwindCommonPalette.RED_800]: '#991B1B',
  [TailwindCommonPalette.RED_900]: '#7F1D1D',
  [TailwindCommonPalette.RED_950]: '#450A0A',

  // TailwindCommonPalette ORANGE colors
  [TailwindCommonPalette.ORANGE_50]: '#FFFAF0',
  [TailwindCommonPalette.ORANGE_100]: '#FEEBC8',
  [TailwindCommonPalette.ORANGE_200]: '#FBD38D',
  [TailwindCommonPalette.ORANGE_300]: '#FFAD1D',
  [TailwindCommonPalette.ORANGE_400]: '#FB923C',
  [TailwindCommonPalette.ORANGE_500]: '#F97316',
  [TailwindCommonPalette.ORANGE_600]: '#EA580C',
  [TailwindCommonPalette.ORANGE_700]: '#C2410C',
  [TailwindCommonPalette.ORANGE_800]: '#9A3412',
  [TailwindCommonPalette.ORANGE_900]: '#7C2D12',
  [TailwindCommonPalette.ORANGE_950]: '#431407',

  // TailwindCommonPalette AMBER colors
  [TailwindCommonPalette.AMBER_50]: '#FFFBEB',
  [TailwindCommonPalette.AMBER_100]: '#FEF3C7',
  [TailwindCommonPalette.AMBER_200]: '#FDE68A',
  [TailwindCommonPalette.AMBER_300]: '#FCD34D',
  [TailwindCommonPalette.AMBER_400]: '#FBBF24',
  [TailwindCommonPalette.AMBER_500]: '#F59E0B',
  [TailwindCommonPalette.AMBER_600]: '#D97706',
  [TailwindCommonPalette.AMBER_700]: '#B45309',
  [TailwindCommonPalette.AMBER_800]: '#92400E',
  [TailwindCommonPalette.AMBER_900]: '#78350F',
  [TailwindCommonPalette.AMBER_950]: '#451a03',

  // TailwindCommonPalette YELLOW colors
  [TailwindCommonPalette.YELLOW_50]: '#FFFEF0',
  [TailwindCommonPalette.YELLOW_100]: '#FEF3C7',
  [TailwindCommonPalette.YELLOW_200]: '#FDE68A',
  [TailwindCommonPalette.YELLOW_300]: '#FCD34D',
  [TailwindCommonPalette.YELLOW_400]: '#FBBF24',
  [TailwindCommonPalette.YELLOW_500]: '#F59E0B',
  [TailwindCommonPalette.YELLOW_600]: '#D97706',
  [TailwindCommonPalette.YELLOW_700]: '#B45309',
  [TailwindCommonPalette.YELLOW_800]: '#92400E',
  [TailwindCommonPalette.YELLOW_900]: '#78350F',
  [TailwindCommonPalette.YELLOW_950]: '#422006',

  // TailwindCommonPalette LIME colors
  [TailwindCommonPalette.LIME_50]: '#F7FEE7',
  [TailwindCommonPalette.LIME_100]: '#ECFCCB',
  [TailwindCommonPalette.LIME_200]: '#D9F99D',
  [TailwindCommonPalette.LIME_300]: '#BEF264',
  [TailwindCommonPalette.LIME_400]: '#A3E635',
  [TailwindCommonPalette.LIME_500]: '#84CC16',
  [TailwindCommonPalette.LIME_600]: '#65A30D',
  [TailwindCommonPalette.LIME_700]: '#4D7C0F',
  [TailwindCommonPalette.LIME_800]: '#3F6212',
  [TailwindCommonPalette.LIME_900]: '#365314',
  [TailwindCommonPalette.LIME_950]: '#1A2E05',

  // TailwindCommonPalette GREEN colors
  [TailwindCommonPalette.GREEN_50]: '#F0FDF4',
  [TailwindCommonPalette.GREEN_100]: '#DCFCE7',
  [TailwindCommonPalette.GREEN_200]: '#BBF7D0',
  [TailwindCommonPalette.GREEN_300]: '#86EFAC',
  [TailwindCommonPalette.GREEN_400]: '#4ADE80',
  [TailwindCommonPalette.GREEN_500]: '#22C55E',
  [TailwindCommonPalette.GREEN_600]: '#16A34A',
  [TailwindCommonPalette.GREEN_700]: '#15803D',
  [TailwindCommonPalette.GREEN_800]: '#166534',
  [TailwindCommonPalette.GREEN_900]: '#14532D',
  [TailwindCommonPalette.GREEN_950]: '#052E16',

  // TailwindCommonPalette EMERALD colors
  [TailwindCommonPalette.EMERALD_50]: '#ecfdf5',
  [TailwindCommonPalette.EMERALD_100]: '#d1fae5',
  [TailwindCommonPalette.EMERALD_200]: '#a7f3d0',
  [TailwindCommonPalette.EMERALD_300]: '#6ee7b7',
  [TailwindCommonPalette.EMERALD_400]: '#34d399',
  [TailwindCommonPalette.EMERALD_500]: '#10b981',
  [TailwindCommonPalette.EMERALD_600]: '#059669',
  [TailwindCommonPalette.EMERALD_700]: '#047857',
  [TailwindCommonPalette.EMERALD_800]: '#065f46',
  [TailwindCommonPalette.EMERALD_900]: '#064e3b',
  [TailwindCommonPalette.EMERALD_950]: '#022c22',

  // TailwindCommonPalette TEAL colors
  [TailwindCommonPalette.TEAL_50]: '#F0FDFA',
  [TailwindCommonPalette.TEAL_100]: '#CCFBF1',
  [TailwindCommonPalette.TEAL_200]: '#99F6E4',
  [TailwindCommonPalette.TEAL_300]: '#5EEAD4',
  [TailwindCommonPalette.TEAL_400]: '#2DD4BF',
  [TailwindCommonPalette.TEAL_500]: '#14B8A6',
  [TailwindCommonPalette.TEAL_600]: '#0D9488',
  [TailwindCommonPalette.TEAL_700]: '#0F766E',
  [TailwindCommonPalette.TEAL_800]: '#115E59',
  [TailwindCommonPalette.TEAL_900]: '#134E4A',
  [TailwindCommonPalette.TEAL_950]: '#042F2E',

  // TailwindCommonPalette CYAN colors
  [TailwindCommonPalette.CYAN_50]: '#ECFEFF',
  [TailwindCommonPalette.CYAN_100]: '#CFFAFE',
  [TailwindCommonPalette.CYAN_200]: '#A5F3FC',
  [TailwindCommonPalette.CYAN_300]: '#67E8F9',
  [TailwindCommonPalette.CYAN_400]: '#22D3EE',
  [TailwindCommonPalette.CYAN_500]: '#06B6D4',
  [TailwindCommonPalette.CYAN_600]: '#0891B2',
  [TailwindCommonPalette.CYAN_700]: '#0E7490',
  [TailwindCommonPalette.CYAN_800]: '#155E75',
  [TailwindCommonPalette.CYAN_900]: '#164E63',
  [TailwindCommonPalette.CYAN_950]: '#083344',

  // TailwindCommonPalette SKY colors
  [TailwindCommonPalette.SKY_50]: '#F0F9FF',
  [TailwindCommonPalette.SKY_100]: '#CFFAFE',
  [TailwindCommonPalette.SKY_200]: '#A5F3FC',
  [TailwindCommonPalette.SKY_300]: '#67E8F9',
  [TailwindCommonPalette.SKY_400]: '#22D3EE',
  [TailwindCommonPalette.SKY_500]: '#06B6D4',
  [TailwindCommonPalette.SKY_600]: '#0891B2',
  [TailwindCommonPalette.SKY_700]: '#0E7490',
  [TailwindCommonPalette.SKY_800]: '#155E75',
  [TailwindCommonPalette.SKY_900]: '#164E63',
  [TailwindCommonPalette.SKY_950]: '#082F49',

  // TailwindCommonPalette BLUE colors
  [TailwindCommonPalette.BLUE_50]: '#EFF6FF',
  [TailwindCommonPalette.BLUE_100]: '#DBEAFE',
  [TailwindCommonPalette.BLUE_200]: '#BFDBFE',
  [TailwindCommonPalette.BLUE_300]: '#93C5FD',
  [TailwindCommonPalette.BLUE_400]: '#60A5FA',
  [TailwindCommonPalette.BLUE_500]: '#3B82F6',
  [TailwindCommonPalette.BLUE_600]: '#2563EB',
  [TailwindCommonPalette.BLUE_700]: '#1D4ED8',
  [TailwindCommonPalette.BLUE_800]: '#1E40AF',
  [TailwindCommonPalette.BLUE_900]: '#1E3A8A',
  [TailwindCommonPalette.BLUE_950]: '#172554',

  // TailwindCommonPalette INDIGO colors
  [TailwindCommonPalette.INDIGO_50]: '#EEF2FF',
  [TailwindCommonPalette.INDIGO_100]: '#E0E7FF',
  [TailwindCommonPalette.INDIGO_200]: '#C7D2FE',
  [TailwindCommonPalette.INDIGO_300]: '#A5B4FC',
  [TailwindCommonPalette.INDIGO_400]: '#818CF8',
  [TailwindCommonPalette.INDIGO_500]: '#6366F1',
  [TailwindCommonPalette.INDIGO_600]: '#4F46E5',
  [TailwindCommonPalette.INDIGO_700]: '#4338CA',
  [TailwindCommonPalette.INDIGO_800]: '#3730A3',
  [TailwindCommonPalette.INDIGO_900]: '#312E81',
  [TailwindCommonPalette.INDIGO_950]: '#1E1B4B',

  // TailwindCommonPalette PURPLE colors
  [TailwindCommonPalette.PURPLE_50]: '#F5F3FF',
  [TailwindCommonPalette.PURPLE_100]: '#EDE9FE',
  [TailwindCommonPalette.PURPLE_200]: '#DDD6FE',
  [TailwindCommonPalette.PURPLE_300]: '#C4B5FD',
  [TailwindCommonPalette.PURPLE_400]: '#A78BFA',
  [TailwindCommonPalette.PURPLE_500]: '#8B5CF6',
  [TailwindCommonPalette.PURPLE_600]: '#7C3AED',
  [TailwindCommonPalette.PURPLE_700]: '#6D28D9',
  [TailwindCommonPalette.PURPLE_800]: '#5B21B6',
  [TailwindCommonPalette.PURPLE_900]: '#4C1D95',
  [TailwindCommonPalette.PURPLE_950]: '#3B0764',

  // TailwindCommonPalette FUCHSIA colors
  [TailwindCommonPalette.FUCHSIA_50]: '#FDF4FF',
  [TailwindCommonPalette.FUCHSIA_100]: '#FAE8FF',
  [TailwindCommonPalette.FUCHSIA_200]: '#F5D0FE',
  [TailwindCommonPalette.FUCHSIA_300]: '#F0ABFC',
  [TailwindCommonPalette.FUCHSIA_400]: '#E879F9',
  [TailwindCommonPalette.FUCHSIA_500]: '#D946EF',
  [TailwindCommonPalette.FUCHSIA_600]: '#C026D3',
  [TailwindCommonPalette.FUCHSIA_700]: '#A21CAF',
  [TailwindCommonPalette.FUCHSIA_800]: '#86198F',
  [TailwindCommonPalette.FUCHSIA_900]: '#701A75',
  [TailwindCommonPalette.FUCHSIA_950]: '#4A044E',

  // TailwindCommonPalette PINK colors
  [TailwindCommonPalette.PINK_50]: '#FDF2F8',
  [TailwindCommonPalette.PINK_100]: '#FCE7F3',
  [TailwindCommonPalette.PINK_200]: '#FBCFE8',
  [TailwindCommonPalette.PINK_300]: '#F9A8D4',
  [TailwindCommonPalette.PINK_400]: '#F472B6',
  [TailwindCommonPalette.PINK_500]: '#EC4899',
  [TailwindCommonPalette.PINK_600]: '#DB2777',
  [TailwindCommonPalette.PINK_700]: '#BE185D',
  [TailwindCommonPalette.PINK_800]: '#9D174D',
  [TailwindCommonPalette.PINK_900]: '#831843',
  [TailwindCommonPalette.PINK_950]: '#500724',

  // TailwindCommonPalette ROSE colors
  [TailwindCommonPalette.ROSE_50]: '#FFF1F2',
  [TailwindCommonPalette.ROSE_100]: '#FFE4E6',
  [TailwindCommonPalette.ROSE_200]: '#FECDD3',
  [TailwindCommonPalette.ROSE_300]: '#FDA4AF',
  [TailwindCommonPalette.ROSE_400]: '#FB7185',
  [TailwindCommonPalette.ROSE_500]: '#F43F5E',
  [TailwindCommonPalette.ROSE_600]: '#E11D48',
  [TailwindCommonPalette.ROSE_700]: '#BE123C',
  [TailwindCommonPalette.ROSE_800]: '#9F1239',
  [TailwindCommonPalette.ROSE_900]: '#881337',
  [TailwindCommonPalette.ROSE_950]: '#4C0519',
};

const tailwindExtraPaletteHex: TailwindExtraPaletteHex = {
  [TailwindExtraPalette.AMBER_500_25]: '#FFC4003F',
  [TailwindExtraPalette.SLATE_400_10]: '#94A3B81A',
  [TailwindExtraPalette.SLATE_400_25]: '#94a3b840',
  [TailwindExtraPalette.BLACK_45]: '#000000',
  [TailwindExtraPalette.WHITE]: '#FFFFFF',
  [TailwindExtraPalette.WHITE_25]: '#FFFFFF40',
  [TailwindExtraPalette.WHITE_50]: '#FFFFFF80',
  [TailwindExtraPalette.WHITE_75]: '#FFFFFFBF',
  [TailwindExtraPalette.GRAY_200_20]: '#E5E7EB33',
  [TailwindExtraPalette.GRAY_200_45]: '#E5E7EB73',
  [TailwindExtraPalette.GRAY_200_50]: '#E5E7EB80',
  [TailwindExtraPalette.GRAY_400_10]: '#9CA3AF1A',
  [TailwindExtraPalette.GRAY_500_45]: '#6B728060',
  [TailwindExtraPalette.NEUTRAL_200_70]: '#D1D5DBB3',
  [TailwindExtraPalette.NEUTRAL_300_80]: '#9CA3AFCC',
  [TailwindExtraPalette.NEUTRAL_800_50]: '#37415180',
  [TailwindExtraPalette.ZINC_400_50]: '#9CA3AF80',
  [TailwindExtraPalette.CYAN_50_25]: '#E0FCFF40',
  [TailwindExtraPalette.CYAN_50_75]: '#E0FCFFBF',
  [TailwindExtraPalette.CYAN_300_25]: '#60A5D940',
  [TailwindExtraPalette.CYAN_950]: '#0B7285',
  [TailwindExtraPalette.VIOLET_50]: '#F3E8FF',
  [TailwindExtraPalette.PURPLE_50]: '#F5F3FF',
  [TailwindExtraPalette.PINK_500_25]: '#EC489940',
  [TailwindExtraPalette.PINK_600_10]: '#DB277730',
  [TailwindExtraPalette.ORANGE_500_25]: '#FB923C40',
  [TailwindExtraPalette.ORANGE_600_10]: '#F9731699',
  [TailwindExtraPalette.ORANGE_RADIAL]: '#F59E0B',
};

export const tailwindPaletteHex: TailwindPaletteHex = {
  ...tailwindCommonPaletteHex,
  ...tailwindExtraPaletteHex,
};
